export default __webpack_public_path__ + "assets/svg/close_icon_white.652d40053547136dd5afe0d2ec93e8f5.svg";